import type { AppLocale } from "./locales";

const KEY = "stratistics.locale";

export function readStoredLocale(): AppLocale | null {
  const v = localStorage.getItem(KEY);
  return v === "en" || v === "fr" ? v : null;
}

export function storeLocale(locale: AppLocale) {
  localStorage.setItem(KEY, locale);
}
